
<template>
  <div name="schools">

     <header class="inner-head">
      <div class="flex justify-between ">
        <h2 class="inner-head-title">School Reporting</h2>

      <ul class="pt-1 right-0">
          <li >
            <button
              type="button"
              class="action-button hover:opacity-75 disabled:opacity-25 disabled:cursor-not-allowed"
               @click="showSchoolReport()"
              :disabled="!hasSchoolsSelected"
            >
               <i class="fas fa-chart-pie"></i>
              View Reports
            </button>
          </li>
        </ul>
      </div>
    </header>

    <div class="filter-bar">
        <ul class="actions">
           <li class="opacity-75">Search:</li>
        <li>
          <input
            type="search"
            class="          filter-bar-search focus:outline-none"
            name="search"
            v-model="search"
            placeholder="Enter search term..."
          />
        </li>
  
      </ul>
    </div>


    <transition name="fade" v-if="loading">
      <div class="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading
      </div>
    </transition>

    <p class="m-6 ml-8 pt-2 text-gray-500">{{filteredList.length}} schools in view - {{selectedSchools.length}} selected to view.
             </p>
                <noaccess v-if="!hasAccess" :blocktype="'outcome'"></noaccess>   

                   <table class="w-95p mx-auto mb-2 h-12 pt-2 align-text-bottom bg-white rounded text-left text-gray-400">
                              <thead>
                                <tr>
                                   <th class="w-1/12 pl-3">Select</th>
                                   <th class="w-4-12">Name</th>
                                   <th class="w-2/12">Events (Pupils)</th>
                                   <th class="w-2/12">EC Clubs (Pupils)</th>
                                   <th class="w-2/12">Assessments</th>
                                  <th class="w-1/12">Active</th>
                                 
                                </tr>
                              </thead>
                            </table>


                                   <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm" >
                              <tbody>
                                <tr v-for="item in filteredList" :key="item.id" class="hover:opacity-50 cursor-pointer" @click="selectSchool(item)"> 

                                   <td class="w-1/12 cursor-pointer text-blue-400 hover:opacity-75 pl-6">
                                  
       
                                            <i class="far text-xl " v-bind:class="schoolIsSelected(item) ? 'fa-check-square': 'fa-square'" ></i> 
                                   
                                  </td>
                                 
                                  <td class="w-4/12 ">{{ item.name }}  </td>
                                   <td class="w-2/12 pl-6">
                                   {{item.event_count}} 
                                   <span class="text-xs opacity-50">
                                   ({{item.event_register_count}})
                                   </span>
                                   </td>
                                   <td class="w-2/12  pl-6">{{item.activity_count}}
                                    <span class="text-xs opacity-50">
                                   ({{item.activity_register_count}})
                                    </span>
                                    </td>
                                   <td class="w-2/12  pl-6">{{item.assessment_count}}</td>
                                   <td class="center w-1/12">
                                    <i class="icon list"  v-bind:class="setActiveClass(item.active)" />
                                   </td>
                                 
                                </tr>
  
                              </tbody>
                              <tfoot>

                              </tfoot>
                            </table>

  </div>


</template>

<script>
import { mapGetters } from "vuex";
import dropdown from "@/components/Dropdown.vue";

const noaccess = () => import("@/components/NoAccess.vue");
import { SchoolService } from "@/services/school.service";


export default {
  name: "schools",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    activeDropdown() {
      this.selectedActive = this.actives[0];
      return this.actives;
    },
    hasSchoolsSelected() {
      return this.selectedSchools.length > 0
    },
    orderedConsuls() {
      var vm = this;
      var active = vm.selectedActive.id;

      if (active == 2) {
        return _.orderBy(this.consuls, ["name"]);
      } else {
        var filtered = vm.consuls.filter(consul => {
          let filtered = true;

          if (filtered) {
            if (active < 2) {
              filtered = consul.active == active;
            }
          }

          return filtered;
        });
        return _.orderBy(filtered, ["name"]);
      }
    },
    filteredList() {
     return this.orderedConsuls.filter(item => {
       var vm = this;
       return item.name.toLowerCase().includes(vm.search.toLowerCase())
     })
   },
  },
  data() {
    return {
      errored: false,
      loading: true,
      hasAccess: false,
      actives: [
        { id: 2, name: "All" },
        { id: 1, name: "Active" },
        { id: 0, name: "Hidden" }
      ],
      selectedActive: {},
      selectedSchools:[],
      consuls: [],
      search: '',
    };
  },
  created() {
    this.loading = true;
    this.hasAccess = this.currentUser.isSchool == false;
    this.fetchData();
  },
  methods: {
    fetchData() {
      SchoolService.getAll("consuls/reporting")
        .then(response => this.buildConsulList(response.data.data))
        .catch(err => {
          console.log("Consuls " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildConsulList(data) {
      this.consuls = data;
    },
    setActiveClass(active) {
      if (active == 1) {
        return "fas fa-check-circle true";
      } else {
        return "fas fa-times-circle false";
      }
    },
    activeSelect(active) {
      this.selectedActive = active;
    },
    parsePostcode(consul) {
      return consul.postcode.Valid == true ? consul.postcode.String : "n/a"
    },
    schoolIsSelected(school) {
      let found = this.selectedSchools.find(s => s.id === school.id)
      return found == undefined ? false : true
    },
    selectSchool(school) {

      if(this.schoolIsSelected(school)){
           this.selectedSchools.splice(this.selectedSchools.findIndex(item => item.id === school.id), 1)
      } else{

        if (this.selectedSchools.length < 6) this.selectedSchools.push(school)
     }
    },
    showSchoolReport() {
        this.$router.push({ name: "OrgSchoolReport", params: { schools: this.selectedSchools } });
    },
  },
  components: {
    dropdown,
    noaccess,
  }
};
</script>


<style scoped>

.button:disabled {
  @apply bg-gray-500 text-gray-400 cursor-not-allowed
}

</style>
